module.exports = __webpack_public_path__ + "static/media/swingHandle_white.90d4e92a.png";